/**
 * UI punctuation as \u escapes so source files stay ASCII-safe on Windows
 * (avoids mojibake when editors save with the wrong encoding).
 */
export const SYM = {
  chevronLeft: "\u2039",
  chevronRight: "\u203A",
  ellipsis: "\u2026",
  close: "\u00D7",
  arrowLeft: "\u2190",
  arrowRight: "\u2192",
  enDash: "\u2013",
  emDash: "\u2014",
  middot: "\u00B7",
  refresh: "\u21BB",
  search: "\u2315",
  check: "\u2713",
  pencil: "\u270E",
  gear: "\u2699",
  menu: "\u2630",
  clipboard: "\uD83D\uDCCB",
  trash: "\uD83D\uDDD1",
  car: "\uD83D\uDE97",
  bell: "\uD83D\uDD14",
};

export function withEllipsis(text) {
  return `${text}${SYM.ellipsis}`;
}
